import React from 'react'

export default function PR() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    window.location.replace(`https://salus.ir/patient-result?c=4&code=${code}`)
    return <p>Loading...</p>
}
